import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { LayoutSplashScreen } from 'src/app/layout';
import { getLeadAutoDropRule } from 'src/app/modules/PulseLeads/network/agentCrud';
import DropLeadRuleForm from 'src/app/modules/PulseLeads/pages/Agent/auto-drop-rule/detail/DropLeadRule';
import { appendAlertItem, AlertType } from '@pruforce/common-adminweb-sdk';

export const LeadDropAgentRulePage: FC<RouteComponentProps> = ({ history, location }) => {
  const [data, setData] = useState({});
  const intl = useIntl();
  const dispatch = useDispatch();
  const Translation = (id: string) => intl.formatMessage({ id });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const res = await getLeadAutoDropRule();
        setData(res);
      } catch (err) {
        dispatch(
          appendAlertItem([
            {
              severity: AlertType.ERROR,
              title: Translation('Error'),
              content: Translation('common.serverError'),
            },
          ]),
        );
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {isLoading ? (
        <LayoutSplashScreen />
      ) : (
        <>
          <DropLeadRuleForm data={data} />
        </>
      )}
    </>
  );
};
